import {BaseApiResponseModel} from "../../infrastructure/models/base-api-response-model";
import {CountryApiModel} from "../common/country/models/country-api-model";
import {SportApiModel} from "../sports/models/sport-api-model";
import {CompetitionApiModel} from "../common/competition/models/competition-api-model";
import {ChartEventsApiModel} from "../full-game/models/chart-events/chart-events.api-model";
import {PartialGameApiModel} from "../partial-game/models/partial-game-api-model";
import {
  AthleteChartEventsApiModel
} from "../full-game/models/chart-events/athlete-chart-events/athlete-chart-events.api-model";
import {AthleteApiModel} from "../common/athlete/athlete-api-model";


export class AthleteEventsChartResponseApiModel extends BaseApiResponseModel {
  stats: ChartEventsApiModel;
  countries: Array<CountryApiModel>;
  competitions: Array<CompetitionApiModel>;
  athletes: Array<AthleteApiModel>;
  sports: Array<SportApiModel>
  games: Array<PartialGameApiModel>
  chartEvents: Array<AthleteChartEventsApiModel>;

  constructor(model: AthleteEventsChartResponseApiModel) {
    super(model);

    this.stats = model?.stats;
    this.sports = model?.sports;
    this.countries = model?.countries;
    this.competitions = model?.competitions;
    this.athletes = model?.athletes;
    this.games = model?.games;
    this.chartEvents = model?.chartEvents;
  }
}
